import { useRouter } from'hooks/navigation-router-with-loading'
import React from 'react'

function Breadcrumbs({ items = [], customClass = '', size = 'm', color }) {
    const router = useRouter();
    const isLast = items.length - 1;

    const sizeStyle = {
        's': 'text-xs',
        'm': 'text-xs md:text-sm'
    }

    return (
        <div className={`flex items-center flex-wrap ${customClass}`}>
            {
                items.map((item, i) => {
                    return (
                        <div key={i} className={` inline-block`}>
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    router.push(item.path);
                                }}
                                href={item.path}
                                className={`leading-5  hover:underline ${sizeStyle[size]} ${i === isLast && 'opacity-40 pointer-events-none'}`}
                            >
                                {item.title?.length > 30
                                    ? item.title.substring(0, 30) + '...'
                                    : item.title
                                }
                            </a>
                            {i !== isLast && <span className='text-gray-900 mx-[9px] leading-5 relative top-[1px] inline-block pointer-events-none'>/</span>}
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Breadcrumbs